import React, { useEffect, useState } from 'react'
import { ServerRequestProtected } from '../../../utils/ServerDataRequest'
import { enumUtil } from '../../../utils/Enum'
import NotificationHandler from '../../../utils/NotificationHandler'

const ViewProfile = ({ receiverUserID, userImage }) => {

    const [userInfo, setUserInfo] = useState({})
    const API_URL_Messages = enumUtil.controller.Messages
    const [isLoading, setisLoading] = useState(false)

    useEffect(() => {
        ServerRequestProtected(API_URL_Messages + "/GetUserInfo", 'post', {
            'TableName': enumUtil.enumAPITableName.Messages,
            'ID': receiverUserID + "",
        }).then((response) => {
            setUserInfo(response)
            setisLoading(false)
        }).catch((error) => {
            setisLoading(false)
            setUserInfo({})
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }, [])
    return (
        <div className='za-new-conversation-screen profile ar_view-profile px-10'>
            {/* <div className='mb-12'>
                <div className='d-flex gap-1 align-items-center za-header '>
                    <span className='icon-box d-flex align-items-center justify-content-center'><i className='icon-arrow-left2'></i></span>
                    <p className='heading fs-14'>Profile</p>
                </div>
            </div> */}
            <div className='d-flex flex-column gap-15'>
                <div className="user-info d-flex justify-content-between align-items-center p-10">
                    <div className="d-flex align-items-center gap-12">
                        <div className="">
                            <img src={userImage ? userImage : 'https://www.w3schools.com/howto/img_avatar.png'} alt="avatar" className='img' />
                        </div>
                        <div className=''>
                            <p className='heading fs-14'>{userInfo.UserName}</p>
                            <p className='text'>{userInfo.UserType}</p>
                        </div>
                    </div>
                    <div className="">
                        <p className="Pat-Pay-clr text font-m fs-11 status-dot">Active</p>
                    </div>
                </div>

                <div className='d-flex flex-column gap-12'>
                    <div className="d-flex align-items-center gap-50 pb-1-5 br-bottom-1 za_br_light">
                        <p className="heading">Email</p>
                        <p className="text">{userInfo.Email ? userInfo.Email : 'N/A'}</p>
                    </div>
                    <div className="d-flex align-items-center gap-20 pb-1-5 br-bottom-1 za_br_light">
                        <p className="heading">Contact #</p>
                        <p className="text">{userInfo.PhoneNumber ? userInfo.PhoneNumber : 'N/A'}</p>
                    </div>


                    {/* <div className='p-12'>
                        <div className='d-flex flex-column gap-20'>

                            <div className='d-flex'>
                                <div className='col-md-2'>
                                    <p className='text font-m fs-12 ar-light-color'>Email:</p>
                                </div>
                                <div className='col-md-6'>
                                    <p className='text font-m fs-12'>{userInfo.Email ? userInfo.Email : 'N/A'}</p>
                                </div>
                            </div>
                            <div className='d-flex'>
                                <div className='col-md-3'>
                                    <p className='text font-m fs-12 ar-light-color'>Phone #</p>
                                </div>
                                <div className='col-md-6'>
                                    <p className='text font-m fs-12'>{userInfo.PhoneNumber ? userInfo.PhoneNumber : 'N/A'}</p>
                                </div>
                            </div>
                            <div className='d-flex'>
                                <div className='col-md-3'>
                                    <p className='text font-m fs-12 ar-light-color'>Location</p>
                                </div>
                                <div className='col-md-9'>
                                    <p className='text font-m fs-12'>{userInfo.Location}</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* <div className='p-12'>
                        <div className='d-flex flex-column gap-15'>
                            <div className='d-flex'>
                                <i className='icon-dash-plus fs-10 align-content-center'></i>
                                <p className='text font-m fs-12 orange-clr'>Create group with Alex</p>
                            </div>
                            <div className='d-flex gap-1' >
                                <div className='avatar-group d-flex justify-content-center align-items-center mb-1'>
                                    <div className="img-container s-35 circle">
                                        <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                                    </div>
                                    <div className="img-container s-35 circle">
                                        <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                                    </div>
                                    <div className="img-container s-35 circle">
                                        <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                                    </div>
                                </div>
                                <div>
                                    <p className='text font-m fs-12'>Group Name</p>
                                    <p className='text fs-11 ar-light-color'>You, ALex</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>

            </div>
        </div>
    )
}

export default ViewProfile